import { useState } from "react"
import { Input } from "web/components/Form/Controls"
import TileWizardActions from "web/components/AddTileWizard/TileWizardActions"

export function ViewableMarketingSummarySettingsModal({
  backButtonHandler,
  close,
  tile,
}) {
  const [title, setTitle] = useState({ value: tile.name })

  async function handleSave() {
    if (title && title.value && /\S/.test(title.value)) {
      await tile.update({
        overview_tile: {
          name: title.value.trim(),
        },
      })
    }

    close()
  }

  return (
    <>
      <div className="modal-content-above-commands">
        <div className="grid gap-y-5">
          <Input label="Title" value={title} onChange={setTitle} />
        </div>
      </div>
      <TileWizardActions
        onSaveHandler={handleSave}
        backButtonHandler={backButtonHandler}
      />
    </>
  )
}
